<template>
  <div style="display: inline-block;"">
    <el-upload
      ref='upload'
      class='upload-demo'
      :action='uploadUrlNew'
      :auto-upload='true'
      :show-file-list='false'
      :data='uploadData'
      :on-success='planOnSuccess'
      :before-upload='beforeUpload'
    >
      <el-button v-if='isButton' type='primary' :size='buttonSize'>{{ uploadText }}</el-button>
      <i v-else class='el-icon-upload el-icon--right'
         style=' color: rgba(51, 136, 255, 1);'>{{ uploadText }}</i>
    </el-upload>
    <el-dialog
      title='提示'
      :visible.sync='dialogVisible'
      width='400px'
      top='35vh'
      append-to-body
      :close-on-click-modal='false'>
      <div style='max-height: 40vh;text-align: left;' v-html='message'></div>
      <div slot='footer' class='dialog-footer'>
        <el-button class='cancel-button' type='primary' size='mini' @click='dialogClose'>
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getImport, getImportUrl} from '@/service/getIP';

export default {
  name: 'batchImport',
  props: {
    //  导入地址
    uploadUrl: {
      type: String,
      default: '',
    },
    uploadText: {
      type: String,
      default: '批量导入',
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    buttonSize: {
      type: String,
      default: 'mini',
    },
    type: {
      type: Number,
      default: 0,
    },
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploadData: {
        mFile: '',//文件名
      },
      dialogVisible: false,
      message: '',
      uploadUrlNew: getImportUrl(this.uploadUrl),
      loading: false,
      result: {}
    };
  },
  methods: {
    setUploadUrlNew(url) {
      this.uploadUrlNew = url;
    },
    /**
     *导入 成功函数
     * @param res 上传成功回调
     */
    planOnSuccess(res) {
      this.$emit('triggerLoading');
      this.result = res;
      this.message = res.message || '导入成功';
      this.dialogVisible = true
      // this.$alert(res.message || '导入成功', '提示', {
      //   confirmButtonText: '关闭',
      //   callback: async () => {
      //     this.$emit('importSuccess', res.data || res);
      //   },
      // });
    },
    dialogClose() {
      this.dialogVisible = false;
      this.message = '';
      this.$emit('importSuccess', this.result.data || this.result);
      this.result = {}
    },
    beforeUpload(file) {
      // console.log(file)
      this.uploadData = {}
      if (file.name.split('.')[1] === 'xls' || file.name.split('.')[1] === 'xlsx') {
        this.$emit('triggerLoading');
        if (this.params) {
          this.uploadData = {
            ...this.params
          }
        };
        this.uploadData['mFile'] = file.name;
        if (this.type) this.uploadData['type'] = this.type;
      } else {
        this.$message.error('请选择excel文件导入！！！');
        return false;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.upload-demo {
  padding-right: 10px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

::v-deep {
  .el-dialog__body {
    max-height: 40vh;
    overflow: auto;
  }

  .cancel-button span {
    color: #fff !important;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
